module.exports = __webpack_public_path__ + "icon_arrowLater.png";